export enum UserRestrictionForceViewOrderFormEnum {
    NormalOrder = 0,
    SharedOrder = 1,
    Both = 2
}